import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { openFullScreenModal } from "store/slices/common/fullScreenMedia.slice";


const VideoThumbnailGenerator = ({ videoUrl }) => {
  const dispatch = useDispatch();
  const videoRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const handleLoadedData = () => {
      setIsLoaded(true);
    };

    const videoElement = videoRef.current;
    if (videoElement) {
      videoElement.addEventListener("loadeddata", handleLoadedData);
    }

    return () => {
      if (videoElement) {
        videoElement.removeEventListener("loadeddata", handleLoadedData);
      }
    };
  }, []);

  return (
    <div
      className="cursor-pointer"
      onClick={() =>
        dispatch(
          openFullScreenModal({
            imageSrc: videoUrl,
            type: "video",
          })
        )
      }
      style={{ width: 300, height: "auto", position: "relative" }}
    >
      {!isLoaded && (
        <div
          style={{
            width: "100%",
            height: "170px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#eee",
            fontSize: "14px",
            color: "#888",
          }}
        >
          Loading thumbnail...
        </div>
      )}

      <video
        ref={videoRef}
        width="300"
        height="auto"
        muted
        playsInline
        preload="metadata"
        style={{
          display: isLoaded ? "block" : "none",
          cursor: "pointer",
          objectFit: "cover",
        }}
      >
        <source src={videoUrl} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      
      {isLoaded && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            pointerEvents: "none", // So clicks go through to the parent div
            width: "60px",
            height: "60px",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="white"
          >
            <path d="M8 5v14l11-7z" />
          </svg>
        </div>
      )}
    </div>
  );
};

export default VideoThumbnailGenerator;
